import { SVGProps } from 'react'

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={13}
    viewBox="0 0 12 13"
    {...props}
  >
    <path d="M6 9a6.992 6.992 0 0 1 5.747 3.004.48.48 0 0 1-.053.612c-.233.236-.62.167-.812-.102A5.99 5.99 0 0 0 6 10a5.993 5.993 0 0 0-4.883 2.515c-.193.268-.578.337-.811.102a.48.48 0 0 1-.054-.612A6.992 6.992 0 0 1 6 9Zm0-9a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z" />
  </svg>
)
export default SvgComponent
